const initialState = false;

const sidebarReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'sidebar/shown':
			return true;
		case 'sidebar/hide':
			return false;
		default:
			return state !== undefined ? state : null;
	}
};

export default sidebarReducer;
